import { useEffect, useState } from 'react'
import { Alert, Button } from 'react-bootstrap'
import pushServices from '../services/pushServices'

const urlBase64ToUint8Array = base64String => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4)
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/')
    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)

    for(let i = 0; i < rawData.length; i += 1) {
        outputArray[i] = rawData.charCodeAt(i)
    }

    return outputArray
}

const getPushSupportMessage = () => {
    if(!('serviceWorker' in navigator)) return 'المتصفح لا يدعم Service Worker'
    if(!('PushManager' in window)) return 'المتصفح لا يدعم إشعارات Push'
    if(!('Notification' in window)) return 'المتصفح لا يدعم الإشعارات'
    return ''
}

const PushNotificationToggle = () => {
    const [loading, setLoading] = useState(false)
    const [enabled, setEnabled] = useState(false)
    const [subscribed, setSubscribed] = useState(false)
    const [message, setMessage] = useState('')
    const [error, setError] = useState('')

    const supportMessage = getPushSupportMessage()

    const getRegistration = async () => {
        const registration = await navigator.serviceWorker.ready
        return registration
    }

    const refreshStatus = async () => {
        if(supportMessage) {
            setError(supportMessage)
            return
        }

        try {
            const { data } = await pushServices.publicKey()
            setEnabled(data.enabled)

            const registration = await getRegistration()
            const currentSubscription = await registration.pushManager.getSubscription()
            setSubscribed(Boolean(currentSubscription))
        } catch (err) {
            setError('تعذر قراءة حالة إشعارات الجوال')
        }
    }

    const enableHandler = async () => {
        setLoading(true)
        setError('')
        setMessage('')

        try {
            const { data } = await pushServices.publicKey()
            if(!data.enabled || !data.publicKey) {
                setEnabled(false)
                setError('إشعارات الجوال تحتاج تفعيل مفاتيح Push في إعدادات السيرفر')
                return
            }

            const permission = await Notification.requestPermission()
            if(permission !== 'granted') {
                setError('لم يتم منح إذن الإشعارات لهذا الجهاز')
                return
            }

            const registration = await getRegistration()
            let subscription = await registration.pushManager.getSubscription()

            if(!subscription) {
                subscription = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: urlBase64ToUint8Array(data.publicKey)
                })
            }

            const response = await pushServices.subscribe(subscription.toJSON())
            setSubscribed(true)
            setMessage(response.data.message)
        } catch (err) {
            setError(err.response && err.response.data ? err.response.data.error : 'تعذر تفعيل إشعارات الجوال')
        } finally {
            setLoading(false)
        }
    }

    const disableHandler = async () => {
        setLoading(true)
        setError('')
        setMessage('')

        try {
            const registration = await getRegistration()
            const subscription = await registration.pushManager.getSubscription()

            if(subscription) {
                await pushServices.unsubscribe(subscription.endpoint)
                await subscription.unsubscribe()
            }

            setSubscribed(false)
            setMessage('تم إيقاف إشعارات الجوال لهذا الجهاز')
        } catch (err) {
            setError('تعذر إيقاف إشعارات الجوال')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        refreshStatus()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className='push-toggle'>
            {error && <Alert variant='warning'>{error}</Alert>}
            {message && <Alert variant='success'>{message}</Alert>}
            {!error && !enabled && <Alert variant='warning'>إشعارات الجوال غير مفعلة من السيرفر حالياً</Alert>}

            <Button
                variant={subscribed ? 'secondary' : 'info'}
                disabled={loading || Boolean(supportMessage) || !enabled}
                onClick={subscribed ? disableHandler : enableHandler}
            >
                {subscribed ? 'إيقاف إشعارات الجوال' : 'تفعيل إشعارات الجوال'}
            </Button>
        </div>
    )
}

export default PushNotificationToggle
